"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledFormattedTextWidget = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("@rjsf/utils");
const viper_formatted_text_transformer_1 = require("@squiz/viper-formatted-text-transformer");
const ArrowBackRounded_1 = __importDefault(require("@mui/icons-material/ArrowBackRounded"));
const Button_1 = __importDefault(require("../../../global/Button/Button"));
const EditorEvents_1 = require("../../../../utilities/EditorEvents/EditorEvents");
const Editor_1 = require("../../Editor");
const transformer = new viper_formatted_text_transformer_1.ViperFormattedTextTransformer();
const DisabledFormattedTextWidget = ({ disabled, formData, idSchema }) => {
    const editorId = idSchema.$id.split(Editor_1.EDITOR_ID_SEPARATOR)[0];
    const attributes = {
        id: idSchema.$id,
        name: idSchema.$id,
        'aria-describedby': (0, utils_1.ariaDescribedByIds)(idSchema),
        'aria-labelledby': (0, utils_1.titleId)(idSchema),
    };
    const handleClick = () => {
        EditorEvents_1.EditorEvents.emit(`${editorId}-fte-clicked`, idSchema.$id);
    };
    const getCurrentValue = (formData) => {
        const html = transformer.toHtml(formData);
        const element = document.createElement('div');
        element.innerHTML = html;
        return element.textContent || element.innerText;
    };
    return (react_1.default.createElement("div", { className: `component-disabled-fte ${disabled && `component-disabled-fte--read-only`}` },
        react_1.default.createElement("input", { ...attributes, className: "component-disabled-fte__input", disabled: true, type: "text", value: getCurrentValue(formData) }),
        react_1.default.createElement(Button_1.default, { className: "component-disabled-fte__button", text: "Access formatted text inline", onClick: handleClick, icon: react_1.default.createElement(ArrowBackRounded_1.default, { className: "icon" }) })));
};
exports.DisabledFormattedTextWidget = DisabledFormattedTextWidget;
